import { create } from "zustand";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL1 } from "../../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../../utils/apiCall";

const frequencyBinsGVPStore = create((set) => ({
  frequencyBinsGVPData: [],
  frequencyBinsGVPInnerData: [],
  frequencyBinsGVPInnerDataLoading: false,
  frequencyBinsGVPInnerDataError: null,
  loading: false,
  error: null,

  // ================= OUTER REPORT =================
  fetchFrequencyBinsGVPOuterReport: async (queryParams) => {
    set({ loading: true, error: null });

    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const response = await apiCall({
        url: `${API_BASE_URL1}GVPReports/Kpi3GvpAttendedDailyOuterReport?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({
        frequencyBinsGVPData: Array.isArray(response) ? response : [],
        loading: false,
        error: null,
      });

    } catch (error) {

      const status = error.response?.status;
      const message = error.response?.data?.message;

      console.log(message || "Error fetching data");
      if (status === 401) {
        toast.error("Session expired. Please login again.");
        localStorage.removeItem("token");
        window.location.href = "/login";

        set({
          frequencyBinsGVPData: [],
          error: "Unauthorized",
          loading: false,
        });
      }

      else if (status === 400) {
        toast.error(error.message || "Bad Request");
        set({
          frequencyBinsGVPData: [],
          error: message || "Bad Request",
          loading: false,
        });
      }

      else if (status === 404) {
        toast.error(error.message);
        set({
          frequencyBinsGVPData: [],
          error: "No Data found.",
          loading: false,
        });
      }

      else if (status === 500) {
        toast.error("Internal Server Error");
        set({
          frequencyBinsGVPData: [],
          error: "Internal Server Error",
          loading: false,
        });
      }
      else {
        toast.error(message || "Something went wrong");
        set({
          frequencyBinsGVPData: [],
          error: message || "Something went wrong",
          loading: false,
        });
      }

    } finally {
      set({ loading: false });
    }
  },

 
  fetchFrequencyBinsGVPInnerReport: async (queryParams) => {

    const queryString = new URLSearchParams(queryParams).toString();

    set({
      frequencyBinsGVPInnerDataLoading: true,
      frequencyBinsGVPInnerDataError: null,
    });

    try {
      const response = await apiCall({
        url: `${API_BASE_URL1}GVPReports/Kpi3GvpAttendedDailyInnerReport?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({
        frequencyBinsGVPInnerData: Array.isArray(response) ? response : [],
        frequencyBinsGVPInnerDataLoading: false,
        frequencyBinsGVPInnerDataError: null,
      });

    } catch (error) {

      const status = error.response?.status;
      const message = error.response?.data?.message;

      if (status === 401) {
        toast.error("Session expired. Please login again.");
        localStorage.removeItem("token");
        window.location.href = "/login";

        set({
          frequencyBinsGVPInnerData: [],
          frequencyBinsGVPInnerDataError: "Unauthorized",
          frequencyBinsGVPInnerDataLoading: false,
        });
      }

      else if (status === 400) {
        toast.error(error.message || "Bad Request");
        set({
          frequencyBinsGVPInnerData: [],
          frequencyBinsGVPInnerDataError: message || "Bad Request",
          frequencyBinsGVPInnerDataLoading: false,
        });
      }

      else if (status === 404) {
        toast.error(error.message);
        set({
          frequencyBinsGVPInnerData: [],
          frequencyBinsGVPInnerDataError: "No Data found.",
          frequencyBinsGVPInnerDataLoading: false,
        });
      }

      else if (status === 500) {
        toast.error("Internal Server Error");
        set({
          frequencyBinsGVPInnerData: [],
          frequencyBinsGVPInnerDataError: "Internal Server Error",
          frequencyBinsGVPInnerDataLoading: false,
        });
      }

      else {
        toast.error(message || "Something went wrong");
        set({
          frequencyBinsGVPInnerData: [],
          frequencyBinsGVPInnerDataError: message || "Something went wrong",
          frequencyBinsGVPInnerDataLoading: false,
        });
      }

    } finally {
      set({ frequencyBinsGVPInnerDataLoading: false });
    }
  },

}));

export default frequencyBinsGVPStore;
